class FileCollection {

    constructor($elt) {
        this.$view = $elt;

        this.prototype = this.$view.data('prototype');
        this.prototype_name = this.$view.data('prototype-name');
        this.index = this.$view.data('index');

        this.init();
        this.bind();
    }

    init() {
        this.addRow();
    }

    bind() {

        // bind delete row
        this.$view.on('click', '.js-umbrella-remove', (e) => {
            // avoid default action
            e.preventDefault();
            e.stopPropagation();
            if (this.rowEmptyCount() > 1) {
                this.delRow($(e.currentTarget).closest('tr'));
            }
            this.$view.trigger('fc:change');
        });

        this.$view.on('change', 'input[type=file]', (e) => {
            const rowEmptyCount =  this.rowEmptyCount();
            if (rowEmptyCount === 0) {
                this.addRow();
            } else if(rowEmptyCount > 1) {
                this.delRow($(e.currentTarget).closest('tr'));
            }

            this.$view.trigger('fc:change');
        });

        // before submit => refresh input row order
        this.$view.closest('form[data-mount="Form"]').on('submit', () => {
            let order = 0;
            this.$view.find('.js-order').each((i, e) => {
                $(e).val(order);
                order++;
            });
        });
    }

    addRow() {
        this.index += 1;
        const regexp = new RegExp(this.prototype_name, "g");
        const $newRow = $(this.prototype.replace(regexp, this.index));
        $newRow.attr('data-empty', true);

        this.$view.data('index', this.index);
        this.$view.find('tbody').first().prepend($newRow);

        // bind row
        new Form($newRow);
        Kernel.mountComponents($newRow)
    }

    delRow($row) {
        $row.remove();
    }

    rowCount() {
        return this.$view.find('tbody tr').length;
    }

    rowEmptyCount() {
        let count = 0;
        this.$view.find('tbody tr .js-umbrella-text').each((i, e) => {
            if ($(e).val().length === 0) {
                count++;
            }
        });
        return count;
    }


}

module.exports = FileCollection;